import { ICategory } from 'common/entities';

export function getChildCategories(
  categoryId: string,
  categories: ICategory[]
) {
  return categories.filter(c => c.parentCategoryId === categoryId);
}
